<img [src]="appLogo" [ngStyle]="{'height': height + 'px'}" alt="logo">